module.exports = __webpack_public_path__ + "img/step1.99a6f23f.png";